module.exports = __webpack_public_path__ + "img/d020f9b41e50f75cabfb256f8c08b13d.f1f395af.png";